import { Link } from 'react-router';

import { cn } from '~/styles/extended-theme';
import { type PropsWithClassName } from '~/utils/props-with-classname';

interface Props {}
export function Footer({ className }: PropsWithClassName<Props>) {
  return (
    <footer className={cn('hidden bg-gray-200 p-4 tablet:block', className)}>
      <div className="flex w-full items-center justify-center gap-2 text-caption">
        <Link
          to="/terms-of-service"
          className="text-caption underline"
          target="_blank"
          rel="noreferrer"
        >
          Terms of Service
        </Link>
        <span>|</span>
        <Link
          to="/privacy-policy"
          className="text-caption underline"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </Link>
        <span>|</span>
        <a
          href="https://fighterspassport.com/contact/"
          className="text-caption underline"
          target="_blank"
          rel="noreferrer"
        >
          Contact Us
        </a>
        <span>|</span>
        <Link to="/request-demo" className="text-caption underline" target="_blank" rel="noreferrer">
          Request Demo
        </Link>
        <span>|</span>
        <p className="text-caption">
          Copyright © {new Date().getFullYear()} Fighters Passport. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
